
export class CheckboxRenderer {
  init(params) {
    this.params = params;

    this.input = document.createElement('i2c-checkbox');
    this.input.checked = params.data.enabled;
    this.input.value = params.data.feature;
    this.input.label = params.data.feature;

    this.input.addEventListener('i2c-change', (event) => {
      params.data.enabled = event.target.checked;

      // Update the full array
      const updatedRowData = params.api.getRenderedNodes().map(node => node.data);
      params.context.methods.setValue("additional_auth_feature_additional_auth", updatedRowData);
      params.context.methods.trigger();
      params.context.handleValueChanges();

      params.api.refreshCells({ force: true });
    });

    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.checked = this.params.data.enabled;
    return true;
  }
}

export class CheckboxRendererReal {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-checkbox');
    this.input.checked = this.params.data.enabled;
    this.input.value = this.params.data.feature;
    this.input.label = this.params.data.feature;
    this.input.addEventListener('i2c-change', (event) => {
      this.params.data.enabled = event.target.checked;
      params.context.methods.setValue(`additional_auth_feature_additional_auth[${params.rowIndex}].feature`, event.target.label);
      params.context.methods.setValue(`additional_auth_feature_additional_auth[${params.rowIndex}].enabled`, event.target.checked);
      params.context.methods.trigger();
      params.context.handleValueChanges();
      params.api.refreshCells({ force: true });
    });
    this.eGui = this.input;
  }

    getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.checked = this.params.data.enabled;
    return true;
  }
}
export class InputRenderer {
  init(params) {
    this.params = params;

    this.input = document.createElement('i2c-input');
    this.input.type = 'text';
    this.input.value = params.data.alternativeMethod || '';
    this.input.disabled = !params.data.enabled;

    this.input.addEventListener('i2c-change', (event) => {
      params.data.alternativeMethod = event.target.value;

      // Update the full array
      const updatedRowData = params.api.getRenderedNodes().map(node => node.data);
      params.context.methods.setValue("additional_auth_feature_additional_auth", updatedRowData);
      params.context.methods.trigger();
      params.context.handleValueChanges();
    });

    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.value = params.data.alternativeMethod || '';
    this.input.disabled = !params.data.enabled;
    return true;
  }
}

export class InputRendererReal {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-input');
    this.input.type = 'text';
    this.input.value = params.data.alternativeMethod;
    this.input.disabled = !params.data.enabled;
    this.input.addEventListener('i2c-change', (event) => {
      this.params.data.alternativeMethod = event.target.value; 
      params.context.methods.setValue(`additional_auth_feature_additional_auth[${params.rowIndex}].alternativeMethod`, event.target.value);
      params.context.methods.trigger();
      params.context.handleValueChanges();
    });
    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.value = this.params.data.alternativeMethod;
    this.input.disabled = !this.params.data.enabled;
    return true;
  }
}
 